import Logs from './views/Logs';
import Log from './views/Log';

export default {
  routes: [
    {
      path: '/module/logs',
      name: 'Logs',
      component: Logs,
      meta: {toolbars: ['Search'], setting_link: 'Logs'}
    },
    {
      path: '/module/logs/:log_id',
      name: 'Log',
      components: {default: Logs, right: Log},
      meta: {toolbars: ['Search'], setting_link: 'Logs'}
    }

  ]
}



// WEBPACK FOOTER //
// ./src/modules/logs/routes.js